import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import FAQListLayer from "../../components/FAQ/FAQListLayer";


const FAQList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="FAQ" />

        {/* UsersListLayer */}
        <FAQListLayer />

      </MasterLayout>

    </>
  );
};

export default FAQList; 
